import type { AnySidebarSection } from '../types/navigation'

/**
 * Moves the FAQ nav item to the end of the visible sidebar list.
 */
export function withSectionAfter<T extends { id: AnySidebarSection }>(
  items: T[],
  sectionId: AnySidebarSection,
  afterSectionId: AnySidebarSection
): T[] {
  const section = items.find((item) => item.id === sectionId)
  const anchorIndex = items.findIndex((item) => item.id === afterSectionId)
  if (!section || anchorIndex === -1) return items
  const withoutSection = items.filter((item) => item.id !== sectionId)
  const insertAt = withoutSection.findIndex((item) => item.id === afterSectionId) + 1
  return [...withoutSection.slice(0, insertAt), section, ...withoutSection.slice(insertAt)]
}

export function withFaqLast<T extends { id: AnySidebarSection }>(items: T[], faqSectionId: AnySidebarSection): T[] {
  const faqItem = items.find((item) => item.id === faqSectionId)
  if (!faqItem) return items
  const withoutFaq = items.filter((item) => item.id !== faqSectionId)
  return [...withoutFaq, faqItem]
}
